import React from "react";
import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";

export default function NotFound() {
  return (
    <div className="max-w-container mx-auto px-4 py-32 text-center min-h-[60vh] flex flex-col items-center justify-center" data-testid="notfound-page">
      <LogoMark size={72} />
      <h1 className="font-serif font-black text-5xl md:text-7xl text-nx-dark mt-6">404</h1>
      <p className="mt-3 text-gray-500 max-w-md">La página que buscás no existe o fue movida.</p>
      <Link to="/" className="mt-6 inline-block nx-gradient-bg text-white font-bold px-8 py-3 rounded-full text-sm uppercase tracking-wider">Volver al inicio</Link>
    </div>
  );
}
